import { gql } from "apollo-boost"

export const GET_HR_COUNTS = gql`
query GetHRCounts($submissionId: ID!) {
    getHRCounts(submissionId: $submissionId) {
      altas
      cambios
      sustitucion
      bajas
      rechazados
    }
  }
`

export const GET_CONSULTANTS_COUNT = gql`
query GetConsultantCounts($submissionId: ID!) {
    getConsultantCounts(submissionId: $submissionId) {
      altas
      cambios
      sustitucion
      bajas
      rechazados
    }
  }
`